// Sample prompts for AI Chat
export const SAMPLE_PROMPTS = [
    {
        category: 'Content / SEO',
        promptName: 'Blog Post',
        promptContent: 'Write a blog post about {topic}, highlighting {key points}.',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Blog Outline',
        promptContent: 'Create a blog outline for {topic}, focusing on',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Backlink Outreach Email',
        promptContent: 'Write an outreach email requesting a backlink exchange',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Customer Case Study',
        promptContent: `Write a customer case study showcasing how {company name & company type}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'FAQ Generator',
        promptContent: 'Create a list of {7} frequently asked questions',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Headline Generator',
        promptContent: 'Create 10 attention-grabbing headlines for',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Landing Page Generator',
        promptContent: `Create website copy about {product details}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Product Brochure',
        promptContent: 'Create a brochure outlining the features and benefits',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Content Rewrite',
        promptContent: `Revise the provided content to enhance its clarity`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'SEO Content Brief',
        promptContent: 'Create an SEO content brief for {target keyword}.',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'SEO Keyword Ideas',
        promptContent: 'Generate a list of 20 keyword ideas on {topic}',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Instant Summary',
        promptContent: 'Write a 50-word summary that summarizes {topic or keyword}.',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Step-by-Step Guide',
        promptContent: 'Create a step-by-step guide that explains how to {topic}.',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Email Marketing',
        promptName: 'Attention, Interest, Desire, Action (AIDA)',
        promptContent: `Using the 'Attention-Interest-Desire-Action' framework, write an email`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Email Marketing',
        promptName: 'Email Subject Generator',
        promptContent: 'Create 5 subject lines that effectively grab the attention',
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Email Marketing',
        promptName: 'Features, Advantages, Benefits (FAB)',
        promptContent: `Using the 'Features-Advantages-Benefits' framework`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Email Marketing',
        promptName: 'Newsletter Generator',
        promptContent: `Turn the information into a long form newsletter`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Email Marketing',
        promptName: 'Pain, Agitate, Solution (PAS)',
        promptContent: `Using the 'Pain-Agitate-Solution' framework, please write an email`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Paid Ads',
        promptName: 'Social Ads',
        promptContent: `Create three variations of ad copy to promote {product} to {audience}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Paid Ads',
        promptName: 'Social Ads PAS',
        promptContent: `Product Name: {Product Name}. Product Description: {Product Description}.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Paid Ads',
        promptName: 'Social Ads Headlines',
        promptContent: `Brainstorm 10 compelling Social ad headlines promoting`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Paid Ads',
        promptName: 'Social Video Script',
        promptContent: `Write a short ad video script for {product description}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Paid Ads',
        promptName: 'Google Ads',
        promptContent: `Create 10 Google ads (headline and description) for {product description}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'PR / Communication',
        promptName: 'Event Invite Email',
        promptContent: `Write a persuasive email to boost attendance at our upcoming event on {theme}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'PR / Communication',
        promptName: 'Company Internal Memos',
        promptContent: `Write an internal memo addressed to {specific department/team} regarding {topic}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'PR / Communication',
        promptName: 'Press Pitching',
        promptContent: `Pitch a story to {reporter name/news media name}.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'PR / Communication',
        promptName: 'Press Release',
        promptContent: `Write a press release for {company or organization} announcing a recent achievement`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Email Marketing',
        promptName: 'Persona Pain Points ',
        promptContent: `Put yourself in the shoes of a {target persona}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Social',
        promptName: 'Caption Generator',
        promptContent: `Write a catchy caption about {your theme}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Social',
        promptName: 'Content Calendar',
        promptContent: `Create a content calendar about {topic}.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Social',
        promptName: 'Engaging Headline',
        promptContent: `Write 5 attention-grabbing titles for a {platform}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Social',
        promptName: 'Instagram Captions',
        promptContent: `Write 5 different Instagram captions for {product}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Social',
        promptName: 'LinkedIn Post',
        promptContent: `Create a narrative Linkedin post using immersive writing about {topic}.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Social',
        promptName: 'TikTok Script',
        promptContent: `Create an engaging TikTok video script about {topic}.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Social',
        promptName: 'Twitter Thread',
        promptContent: `Give a controversial opinion on {topic}, then turn it into a twitter thread.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Social',
        promptName: 'Youtube Video Description',
        promptContent: `Write a 100-word YouTube video description that urges {target audience}`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Summarize Text',
        promptContent: `Given: {text}. Please summarize`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Sentiment Analysis',
        promptContent: `Given: {text}. Evaluate the sentiment`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Customer Service',
        promptName: 'Respond to a Complaint',
        promptContent: `Given complaint info: {complaint context}.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Customer Service',
        promptName: 'Follow up Email on issue',
        promptContent: `Given customer's name & issue details:`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Customer Service',
        promptName: 'Respond to a Refund',
        promptContent: `Given refund info: {refund info & policy}.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Text Processing',
        promptName: 'Text Anonymization and Redaction',
        promptContent: `Given: {text}. It contains sensitive`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Text Processing',
        promptName: 'Detect Language',
        promptContent: `Given: {text}. Identify the predominant`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Analyze Word Frequency',
        promptContent: `Given: {text}. Analyze the frequency`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Text Processing',
        promptName: 'Identify Text Types',
        promptContent: `Given: {text}. Identify the text type`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Sales',
        promptName: 'Generate Relevant Angles',
        promptContent: `Given prospect's company info & your company value`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Business',
        promptName: 'Generate Lingo Map',
        promptContent: `Given website URL: {the website URL}. Please generate 1-7 terms for the lingo map.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Content / SEO',
        promptName: 'Check Grammar',
        promptContent: `Given {text}. Check the grammar.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Education',
        promptName: 'Explain with Analogy',
        promptContent: `Given {topic}. Explains through creative real-world analogies:`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Business',
        promptName: 'Compare Competitor',
        promptContent: `Given competitors info & our company info:`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Business',
        promptName: 'Expand to New Market',
        promptContent: `Given: {target country}. Understanding the unique market dynamics, cultural nuances,`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Business',
        promptName: 'Analyze Market Trend',
        promptContent: `Given: {industry}. Identify current market trends`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Product',
        promptName: 'Painpoints to Features',
        promptContent: `Given: {painpoints}. For each of the above pain points,`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Product',
        promptName: 'Issues to Help Articles',
        promptContent: `Given reported bug or issues: {issue details}. Create a comprehensive and user-friendly knowledge`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Product',
        promptName: 'Measure KPI for features',
        promptContent: `Given feature: {feature info}. Develop a comprehensive set of Key Performance Indicators (KPIs)`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Product',
        promptName: 'Analyze Transcript',
        promptContent: `Given the chat transcript: {chat transcript}. Please analyze`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Sales',
        promptName: '3 Step Outreach Sequence',
        promptContent: `Given: {company URL}. Generate a 3 step outreach sequence.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Sales',
        promptName: 'Personalized Cold Email',
        promptContent: `Given prospect: {linkedin profile url} & my offering {product/services}.`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Strategy',
        promptName: 'Reframe Business Perspectives',
        promptContent: `Given my business decision: {info}. Apply Reframing Business Perspectives`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Strategy',
        promptName: 'Behavioral Economics Principles',
        promptContent: `Given my business decision: {info}. Apply Behavioral Economics Principles`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Strategy',
        promptName: 'Blue Ocean Strategy',
        promptContent: `Given my business decision: {info}. Apply the Blue Ocean Strategy`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Strategy',
        promptName: 'Brand Ecosystem Development',
        promptContent: `Given my business decision: {info}. Utilize Brand Ecosystem`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Strategy',
        promptName: 'Consumer Behavior Analysis',
        promptContent: `Given my business decision: {info}. Use Consumer Behavior Analysis`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Strategy',
        promptName: 'Cost-Benefit Analysis',
        promptContent: `Given my business decision: {info}. Apply Cost-Benefit Analysis`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Strategy',
        promptName: 'Customer Lifetime Value',
        promptContent: `Given my business decision: {info}. Assess my business decision`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Strategy',
        promptName: 'Customer Persona Building',
        promptContent: `Given my business decision: {info}. Utilize Customer Persona Building`,
        promptAuthor: 'Studio Global',
    },
    {
        category: 'Strategy',
        promptName: 'Disruptive Innovation',
        promptContent: `Given my business decision: {info}. Apply Disruptive Innovation`,
        promptAuthor: 'Studio Global',
    },
];
